import { css } from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';

const chanelTheme = {
    Headline: css`
        font-size: 16px;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: 600;
        padding: 0 ${Spacing16};
    `,
    HeadlineContainer: css`
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;

        &:before {
            border-top: 1px solid #b8b8b8;
            content: '';
            display: flex;
            height: 1px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 100%;
            z-index: -1;
        }
    `
};

export default chanelTheme;

